import { Site } from '../../constants/siteList'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../localStorageHelpers'

const itemKey = (site: Site) => {
  return `${site}-search-page-views`
}

export const shouldTrackSearchCount = (site: Site) => {
  return (
    site === Site.themeforest ||
    site === Site.codecanyon ||
    site === Site.graphicriver
  )
}

export const searchesCount = (site: Site) => {
  return getLocalStorageItem(itemKey(site), 0)
}

export const countSearchFor = (site: Site) => {
  const newCount = getLocalStorageItem(itemKey(site), 0) + 1
  setLocalStorageItem(itemKey(site), newCount)
}
